export enum ListFilter {
  ALL = 'all',
  HOME_VISIT = 'Home Visit',
  ONLINE_CONSULTATION = 'Online Consultation',
  CLINICS = 'Clinic',
}
